<template>
    <div class="card application_card">
        <div class="card__header">
            <h2>{{ application.title }}</h2>
            <i class="fas fa-times close" @click="$emit('close')"></i>
        </div>
        <div class="card__content">
            <div>
                <h3>Funktionsweise</h3>
                <div v-html="application.description"></div>
                <br>
                <button class="button" @click="$emit('usage')">Pädagogischer Nutzen</button>
            </div>
            <button class="button add" @click="$emit('toggle')" :class="{active: application.active}">{{ application.active ? 'Entfernen' : 'Hinzufügen'}}</button>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['application']
    };
</script>

<style scoped lang="scss">
    .add {
        width: 100%;
    }

    .add.active {
        background-color: $orange;
    }

    .close {
        font-size: 30px;
        position: absolute;
        right: 20px;
        top: 15px;
        cursor: pointer;
    }
</style>
